<template>
  <div class="container">
    <div class="content">
      <div class="title"><h3>{{title}}</h3><a @click="changeMethod">切换({{inverseTitle}})</a></div>
      <el-form :inline="true" :model="address" ref="addressForm">
        <div class="searchItem" v-if="isPositive">
        <el-form-item prop="provinceCode" :rules="[{
            required: isPositive,
            message: '请选择省份',
            trigger: 'change'
          }]">
          <el-select
            style="width:200px;"
            placeholder="请选择省份"
            clearable
            ref="provinceCode"
            filterable
            v-model="address.provinceCode"
            @change="getCity">
            <el-option v-for="item in provinceList" :label="item.fAreaName" :value="item.fAreaCode" :key="item.fAreaCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="cityCode" :rules="[{
            required: isPositive,
            message: '请选择地市',
            trigger: 'change'
          }]">
          <el-select
            style="width:200px;"
            placeholder="请选择地市"
            ref="cityCode"
            clearable
            filterable
            v-model="address.cityCode"
            @change="getArea">
            <el-option v-for="item in cityList" :label="item.fAreaName" :value="item.fAreaCode" :key="item.mccCofAreaCodede"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="areaCode" :rules="[{
            required: isPositive,
            message: '请选择区县',
            trigger: 'change'
          }]">
          <el-select
            style="width:200px;"
            placeholder="请选择区县"
            ref="areaCode"
            filterable
            clearable
            v-model="address.areaCode"
            @change="changeAreaCode">
            <el-option
              v-for="item in areaList"
              :key="item.fAreaCode"
              :label="item.fAreaName"
              :value="item.fAreaCode" ></el-option>
          </el-select>
        </el-form-item>
        </div>
        <div class="searchItem" v-else>
        <el-form-item prop="addressCode" :required="!isPositive">
          <el-input
              style="width:200px;"
              placeholder="请输入地区码"
              clearable
              v-model="address.addressCode"
              @input="() => {this.showResult = false}">
            </el-input>
        </el-form-item>
        </div>
        <el-form-item>
          <el-button @click="onSubmit" :loading="searchLoading">查询</el-button>
        </el-form-item>
        </el-form>
      <div class="result" v-if="showResult && isPositive">
        <h4>结果</h4>
        <div class="resultItem"><span class="label">省份</span>{{address.provinceResult}}</div>
        <div class="resultItem"><span class="label">省地区码</span>{{address.provinceCode}}</div>
        <div class="resultItem"><span class="label">地市</span>{{address.cityResult}}</div>
        <div class="resultItem"><span class="label">市地区码</span>{{address.cityCode}}</div>
        <div class="resultItem"><span class="label">区县</span>{{address.areaResult}}</div>
        <div class="resultItem"><span class="label">区地区码</span>{{address.areaCode}}</div>
      </div>
      <div class="result" v-if="showResult && !isPositive">
        <h4>结果</h4>
        <div class="resultItem"><span class="label">名称</span>{{address.addressResult}}</div>
        <div class="resultItem"><span class="label">地区码</span>{{address.addressCode}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { getProvinceAlipay, getCityAlipay, getAreaAlipay, getAreaByCode } from '@/api/global'
import { parseTime } from '@/utils/formatTime'
export default {
  data () {
    return {
      isPositive: true, // true: 通过行业分类查询mcc false: 根据mcc查询行业分类
      title: '根据地区查询地区码',
      inverseTitle: '根据地区码查询地区',
      provinceList: [],
      cityList: [],
      areaList: [],
      showResult: false,
      address: {
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        addressCode: '',
        provinceResult: '',
        cityResult: '',
        areaResult: '',
        addressResult: ''
      },
      mcc: '',
      searchLoading: false
    }
  },
  mounted () {
    this.getProvince()// 获取行业类型
  },
  methods: {
    changeMethod () {
      [this.title, this.inverseTitle] = [this.inverseTitle, this.title]
      this.showResult = false
      this.isPositive = !this.isPositive
    },
    /**
     * @description 选中行业大类后获取行业小类列表
     * @param {Number} id 选中的大类id
     */
    getProvince () {
      this.showResult = false
      getProvinceAlipay().then(res => {
        if (parseInt(res.result_cde) !== 0) {
          this.$message({
            showClose: true,
            message: res.result_msg,
            type: 'error'
          })
        } else {
          this.provinceList = res.data
        }
      })
    },
    getCity (code) {
      this.address.cityCode = ''
      this.address.areaCode = ''
      this.cityList = []
      this.areaList = []
      this.$nextTick(() => {
        this.address.provinceResult = this.$refs.provinceCode.selectedLabel
      })
      if (code) {
        getCityAlipay(qs.stringify({ parentCode: code })).then(res => {
          if (parseInt(res.result_cde) !== 0) {
            this.$message({
              showClose: true,
              message: res.result_msg,
              type: 'error'
            })
          } else {
            this.cityList = res.data
          }
        })
      }
    },
    getArea (code) {
      this.address.areaCode = ''
      this.areaList = []
      this.$nextTick(() => {
        this.address.cityResult = this.$refs.cityCode.selectedLabel
      })
      if (code) {
        getAreaAlipay(qs.stringify({ parentCode: code })).then(res => {
          if (parseInt(res.result_cde) !== 0) {
            this.$message({
              showClose: true,
              message: res.result_msg,
              type: 'error'
            })
          } else {
            this.areaList = res.data
          }
        })
      }
    },
    changeAreaCode () {
      this.showResult = false
      this.$nextTick(() => {
        this.address.areaResult = this.$refs.areaCode.selectedLabel
      })
    },
    onSubmit () {
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          if (this.isPositive) {
            this.showResult = true
          } else {
            this.searchLoading = true
            const date = parseTime(new Date(), '{yy}{mm}{dd}{hh}{ii}')
            const params = qs.stringify({
              agentId: date,
              reqSerialNo: date,
              data: JSON.stringify({ areaCode: this.address.addressCode })
            })
            getAreaByCode(params).then((res) => {
              this.searchLoading = false
              if (res.data.length > 0) {
                this.address.addressResult = res.data[0].areaName
                this.showResult = true
              } else {
                this.$message({
                  showClose: true,
                  type: 'error',
                  message: '地区码有误，无法查询对应地址信息'
                })
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    background-color: #f0f2f5;
    .content{
      width:1000px;
      height:100%;
      overflow-y: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      border-radius: 11px;
      background:rgba(255,255,255,1);
      padding: 30px;
      .title {
        margin-bottom: 30px;
        h3 {
          display: inline-block;
          margin-right: 30px;
        }
        a {
          color: #1482f0;
        }
      }
      .searchItem {
        display: inline-block;
      }
      .result {
        margin-top: 50px;
        .resultItem {
          margin-top: 15px;
        }
        .label {
          display: inline-block;
          width: 100px;
          margin-right: 10px;
        }
      }
    }
  }
</style>
